import {api} from "../config";

export default {
  data () {
    return {
      Log: (this.getLog()) ? this.getLog() : [],
      LessonLog: (this.getLessonLog()) ? this.getLessonLog() : [],
      question_item: {
        type: '',
        content_id: '',
        question_id: '',
        answer: null,
        selected: '',
      },
      lesson_item: {
        content_id: '',
        score_result: null,
      }
    }
  },
  mounted() {
  },
  methods: {
    setLog(log) {
      window.sessionStorage.setItem('question_log', JSON.stringify(log));
    },
    getLog() {
      return JSON.parse(window.sessionStorage.getItem('question_log'));
    },
    removeLog() {
      window.sessionStorage.removeItem('question_log');
    },
    // for Lesson Log
    setLessonLog(log) {
      window.sessionStorage.setItem('lesson_log', JSON.stringify(log));
    },
    getLessonLog() {
      return JSON.parse(window.sessionStorage.getItem('lesson_log'));
    },
    removeLessonLog() {
      window.sessionStorage.removeItem('lesson_log');
    },

    questionTempLog(type, question_id, answer, selected) {
      this.question_item = {
          type: type,
          content_id: this.$store.getters.content_id(this.step),
          question_id:  question_id,
          answer: answer,
          selected: selected
      };

      this.Log.push(this.question_item)
      this.setLog(this.Log);

      // initialize
      this.question_item = {
        type: '',
        content_id: '',
        question_id: '',
        answer: null,
        selected: '',
      }
    },

    lessonTempLog(score_result) {
      this.lesson_item = {
          content_id: this.$store.getters.content_id(this.step),
          score_result:  score_result
      };

      this.LessonLog.push(this.lesson_item)
      this.setLessonLog(this.LessonLog);

      // initialize
      this.lesson_item = {
        content_id: '',
        score_result: null,
      }
    },


    questionLog() {
      axios.post(api.updateQuestionLog, {
        lesson_id: this.$store.getters.lesson_data.lesson_id,
        log: this.getLog(),
        lessonlog: this.getLessonLog()
      })
      .then((resp) => {
        this.removeLog();
        this.removeLessonLog();
      })
    },
  }
}